export default "__VITE_ASSET__B0GMCvzL__"